import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/product-detail/product-skeleton.tsx");
